import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class AccountingDashboardService {
  url: string = 'accounting/dashboard';

  constructor(private httpClient: HttpClientService) {}

  getDashboard(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`);
  }
}
